import React from "react"
import { UrlService } from "../../../../core/services/UrlService"
import "./Banner.scss"
import $ from "jquery"

const Banner: React.FC<any> = () => {
    const [Background, setBackground] = React.useState<any>(
        UrlService.getLocalImageUrl("self-test/covid/img01.png?1")
    )

    React.useEffect(() => {
        let newWidth = window.innerWidth
        if (newWidth <= 768) {
            setBackground(
                UrlService.getLocalImageUrl(
                    "self-test/covid/img01_mobile.png?1"
                )
            )
        }
    }, [])

    React.useEffect(() => {
        window.addEventListener("resize", function (event) {
            let newWidth = window.innerWidth
            if (newWidth <= 768) {
                setBackground(
                    UrlService.getLocalImageUrl(
                        "self-test/covid/img01_mobile.png?1"
                    )
                )
            } else {
                setBackground(
                    UrlService.getLocalImageUrl("self-test/covid/img01.png?1")
                )
            }
        })
    }, [])

    const moveToSelfTest = () => {
        $("html, body").animate(
            {
                scrollTop:
                    $(".self-test-questions_container").position()?.top - 50 ||
                    0,
            },
            1000
        )
    }
    return (
        <section>
            <div
                className="self-test-banner_background"
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className="self-test-banner_container container">
                    <h1 className="self-test-banner_title">2019冠狀病毒</h1>
                    <div className="self-test-banner_sub-title">⾃我評估</div>
                    <div className="self-test-banner_cta-container">
                        <span className="self-test-banner_cta_button">
                            <span className="self-test-banner_button-icon">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="11"
                                    height="14"
                                    className="self-test-banner_button-arrow"
                                >
                                    <path
                                        fill="currentColor"
                                        fillRule="evenodd"
                                        d="M0 0l11 7-11 7z"
                                    ></path>
                                </svg>
                            </span>
                            <span
                                className="self-test-banner_label"
                                onClick={moveToSelfTest}
                            >
                                立即開始評估
                            </span>
                        </span>
                    </div>
                    <p className="self-test-banner_introduction">
                        香港疫情反復，變異病毒株Omicron更引發了最新的第五波疫情<sup>1</sup>，您我都有可能確診或成為密切接觸者。消息指出Omicron症狀比較輕，令不少患者忽視了感染2019新型冠狀病毒的嚴重性，延誤最佳的診治時機。其實Omicron的症狀雖然比以往病毒株Delta輕微，但仍然非常危險，嚴重更可導致死亡<sup>2</sup>。
                        <br />
                        <br />
                        懷疑⾃⼰中招就應及早接受治療，才能盡快康復。
                    </p>
                </div>
            </div>
        </section>
    )
}

export default Banner
